<template>
    <div class="switch-container">
        <label class="switch">
            <input v-model="checked" :disabled="disabled" type="checkbox" />
            <span class="slider round"></span>
        </label>
    </div>
</template>
<script>
    export default {
        name: 'SwitchToggle',
        props: {
            initialState: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        emits: ['switch-checked', 'switch-unchecked'],
        data: () => ({
            checked: false
        }),
        watch: {
            checked: function (checked) {
                checked ? this.$emit('switch-checked') : this.$emit('switch-unchecked')
            }
        },
        created() {
            this.checked = this.initialState
        }
    }
</script>
<style lang="scss" scoped>
    .switch-container {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;

        input:checked + .slider {
            background-color: #cdeb09;
        }

        input:focus + .slider {
            box-shadow: 0 0 1px #cdeb09;
        }
        input:checked + .slider:before {
            transform: translateX(26px);
            background-color: black;
        }

        .slider {
            position: absolute;
            cursor: pointer;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: black;
            transition: 0.4s;
        }

        .slider:before {
            position: absolute;
            content: '';
            height: 26px;
            width: 26px;
            left: 4px;
            bottom: 4px;
            background-color: #8b8b8b;
            transition: 0.4s;
        }
        .slider.round {
            border-radius: 34px;
        }

        .slider.round:before {
            border-radius: 50%;
        }
    }
    .switch-container input {
        opacity: 0;
        width: 0;
        height: 0;
    }
</style>
